import React from 'react'

const App = () => {
  return (
    <div class='app'>
      <header>
        <a href='https://www.redbull.com'>
          <img
            src="https://resources.redbull.com/logos/redbullcom/v3/redbullcom-logo.svg"
            alt="Red Bull Logo"
            className="header-logo"
          />
        </a>
      </header>
      <video id='video' src='https://activations.redbull.com/lsr_tradeshow/lsr_vid.mp4' controls />
      <div id='contact'>
        <p class='name'>Steven Bremmer</p>
        <p class='title'>On Premise National Accounts Manager</p>
        <a href='mailto:josh.cardinal@redbull.com'><p class='email'>steve.bremmer@redbull.com</p></a>
      </div>
    </div>
  )
}

export default App